// Copyright (c) 2016 Deere & Company

import './search-box.scss';
import React, {PropTypes} from 'react';
import {injectIntl, intlShape} from 'react-intl';
import TranslatedInput from '../translated-input';

function handleTextChange(event) {

    this.onQueryChange(event.target.value);

}

function onSubmit(event) {

    this.onSearch(this.queryString.trim());

    event.preventDefault();

}

function handleFocus(event) {

    if (event.target.value) {

        event.target.select();

    }

}

const SearchBox = props =>

    props.searchBy &&
        <form
            className='search-box'
            onSubmit={props::onSubmit}
            spellCheck={false}
        >
            <div className='sort-by-group'>
                <label className='sap-down-label'> {props.intl.formatMessage({id: props.searchBy})}</label>
            </div>
            <TranslatedInput
                onChange={props::handleTextChange}
                onFocus={props::handleFocus}
                placeholder={props.placeholderText}
                type='text'
                value={props.queryString}
            />
            <button
                className='search-button'
            >
                <span className='icon-search'/>
            </button>
        </form>;

SearchBox.displayName = 'SearchBox';
SearchBox.propTypes = {
    defaultOption: PropTypes.string,
    intl: intlShape.isRequired,
    onOptionChange: PropTypes.func.isRequired,
    onQueryChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    placeholderText: PropTypes.string.isRequired,
    queryString: PropTypes.string,
    searchBy: PropTypes.string.isRequired
};

export default injectIntl(SearchBox);



// WEBPACK FOOTER //
// ./src/shared/components/search-box/search-box-sap-down.js